import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ButtonThemeEnum} from "../../shared/ui/button/button-theme-enum";
import {SeuilEgalimDto} from "../../core/dtos/egalim/seuil-egalim-dto";


@Component({
    selector: 'yo-indicateur-egalim',
    templateUrl: './indicateur-egalim.component.html',
    styleUrls: ['./indicateur-egalim.component.scss'],
    standalone: false
})

export class IndicateurEgalimComponent {

  @Input() values: any[] = [];
  @Input() palettes: any[] = [];
  @Input() inputSeuils: SeuilEgalimDto[] = [];
  @Input() isConformeEgalim: boolean = false;
  @Input() startValue: number = 0;
  @Input() endValue: number = 100;
  @Input() subtitle: string = '';
  @Input() titleText: (arg: any) => string;
  @Input() tooltipText: (arg: any) => string;
  @Input() legendText: (arg: any) => string;

  @Output() onChangeSeuil = new EventEmitter<SeuilEgalimDto[]>();

  emitChangeSeuil() {
    this.onChangeSeuil.emit(this.inputSeuils);
  }
}
